import { Card, CardContent, CardHeader } from '@eigtech/ui/components/card'
import { createFileRoute } from '@tanstack/react-router'
import { TypographyH4 } from '@eigtech/ui/components/typopgraphy'
import { InspectionsTable } from '@eigtech/ui-shared-inspections-web'
import { ensureJobCorn } from '@eigtech/restoration-util'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/inspections')({
  component: RouteComponent,
})

function RouteComponent() {
  const { jobId } = Route.useParams()

  return (
    <Card>
      <CardHeader>
        <TypographyH4>Inspections</TypographyH4>
      </CardHeader>
      <CardContent>
        <InspectionsTable entityId={ensureJobCorn(jobId)} />
      </CardContent>
    </Card>
  )
}
